"use strict";

var _taggedTemplateLiteral = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  box-shadow: none;\n  border: none;\n  overflow: visible;\n  padding: ", ";\n  &:empty {\n    display: none;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  background: ", ";\n  box-shadow: ", ";\n  padding: ", ";\n  border: solid 1px ", ";\n  overflow: hidden;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  flex-direction: column;\n  align-items: ", ";\n  > :not(:last-child) {\n    margin-bottom: ", " !important;\n    margin-right: 0 !important;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: ", ";\n  justify-content: ", ";\n  > :not(:last-child) {\n    margin-right: ", " !important;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin: auto;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-top: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n  margin-right: ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  &:empty {\n    display: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentBlock = exports.LargeBlock = exports.VSpaced = exports.HSpaced = exports.Space = exports.Spacer = exports.Block = void 0;

var styled_components_1 = __importDefault(require("styled-components"));

var getSize = function getSize(identifier, theme) {
  if (identifier === true) {
    return theme['@size-xs'];
  } else if (identifier) {
    return theme[identifier];
  } else return 0;
};

exports.Block = styled_components_1["default"].div(_templateObject(), function (props) {
  return getSize(props.marginTop, props.theme);
}, function (props) {
  return getSize(props.marginBottom, props.theme);
}, function (props) {
  return getSize(props.marginLeft, props.theme);
}, function (props) {
  return getSize(props.marginRight, props.theme);
}, function (props) {
  return getSize(props.paddingTop, props.theme);
}, function (props) {
  return getSize(props.paddingBottom, props.theme);
}, function (props) {
  return getSize(props.paddingLeft, props.theme);
}, function (props) {
  return getSize(props.paddingRight, props.theme);
});
exports.Spacer = styled_components_1["default"].div(_templateObject2(), function (props) {
  return props.horizontal ? getSize(props.horizontal, props.theme) : 0;
}, function (props) {
  return props.vertical ? getSize(props.vertical, props.theme) : 0;
});
exports.Space = styled_components_1["default"].div(_templateObject3());
exports.HSpaced = styled_components_1["default"].div(_templateObject4(), function (props) {
  return props.align || 'center';
}, function (props) {
  return props.justify || 'flex-start';
}, function (props) {
  return getSize(props.space || true, props.theme);
});
exports.VSpaced = (0, styled_components_1["default"])(exports.HSpaced)(_templateObject5(), function (props) {
  return props.align || 'flex-start';
}, function (props) {
  return getSize(props.space || true, props.theme);
});
exports.LargeBlock = styled_components_1["default"].div(_templateObject6(), function (props) {
  return props.theme['@border-radius-large'];
}, function (props) {
  return props.theme['@gray-0'];
}, function (props) {
  return props.theme['@shadow-medium'];
}, function (props) {
  return props.theme['@padding-md'];
}, function (props) {
  return props.theme['@border-color-split'];
});
exports.ContentBlock = (0, styled_components_1["default"])(exports.LargeBlock)(_templateObject7(), function (props) {
  return props.theme[props.compact ? '@size-s' : '@size-l'];
});